export default class LocalStorageManager {
	static getLocalStorage<T>(key: string): T | null {
		try {
			const data = window.localStorage.getItem(key);
			return data ? (JSON.parse(data) as T) : null;
		} catch (error) {
			console.error(error);
			return null;
		}
	}

	static setLocalStorage<T>(key: string, value: T): boolean {
		try {
			window.localStorage.setItem(key, JSON.stringify(value));
			return true;
		} catch (error) {
			console.error(error);
			return false;
		}
	}

	static removeLocalStorage(key: string): boolean {
		try {
			if (window.localStorage.getItem(key) !== null) {
				window.localStorage.removeItem(key);
				return true;
			}
			return false;
		} catch (error) {
			console.error(error);
			return false;
		}
	}

	static hasLocalStorage(key: string): boolean {
		return window.localStorage.getItem(key) !== null;
	}
}
